import React from "react";

interface Props {
  label: string;
  value: number;
  unit: string;
  onChange: (value: number, unit: string) => void;
}

const DurationInputWithUnit: React.FC<Props> = ({
  label,
  value,
  unit,
  onChange,
}) => {
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    onChange(val === "" ? 0 : Number(val), unit);
  };

  const handleUnitChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newUnit = e.target.value;
    onChange(value, newUnit);
  };

  return (
    <div className="mb-4 w-full">
      <label className="block mb-2 font-medium">{label}</label>
      <div className="flex gap-2 w-full">
        <input
          type="number"
          value={value === 0 ? "" : value}
          onChange={handleValueChange}
          className="`w-full border rounded-md p-2 focus:outline-none focus:ring-1 focus:ring-primary min-h-[60px]"
          style={{ width: "100%" }}
        />
        <select
          value={unit}
          onChange={handleUnitChange}
          className="border p-2 rounded"
        >
          <option value="seconds">Seconds</option>
          <option value="hours">Hours</option>
          <option value="days">Days</option>
        </select>
      </div>
    </div>
  );
};

export default DurationInputWithUnit;
